import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'
import { z } from 'zod'

import { GoalConfigsTable } from '../../../../../../components/GoalConfigsTable.tsx'

const Page = (): ReactElement => {
  const { organizationId } = Route.useParams()
  return <GoalConfigsTable organizationId={organizationId} />
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/goal_configs/')({
  validateSearch: (search) => z.object({ dashboardViewId: z.string().optional() }).parse(search),
  component: Page,
})
